import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgGaruda from '../../../assets/images/pngwing.png';
import srcHanSans from '../../../assets/custom/font/china_han/Source_Han_Sans_CN_Light.otf';
import srcHanBold from '../../../assets/custom/font/china_han/Source_Han_Sans_CN_Bold.otf';
import srcTimesRus from '../../../assets/custom/font/times/timesrus.ttf';
import srcTimesRusBold from '../../../assets/custom/font/times/timesrusbd.ttf';
import srcTimes from "../../../assets/custom/font/times/times.ttf";
import srcTimesBold from "../../../assets/custom/font/times/timesbd.ttf";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import imgStempel from '../../../assets/images/stempel.jpg';

Font.register({ family: 'Source Han Sans CN Light', src: srcHanSans })
Font.register({ family: 'Source Han Sans CN Bold', src: srcHanBold })

Font.register({ family: 'Times Russian', src: srcTimesRus })
Font.register({ family: 'Times Russian Bold', src: srcTimesRusBold })

Font.register({ family: "Times", src: srcTimes });
Font.register({ family: "TimesBold", src: srcTimesBold });

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 5,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 8,
        textAlign: "center",
        marginBottom: 2
    },
    table: {
        display: "table",
        width: "auto",
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        // padding: 1,
    },
    tableColPoint: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        paddingLeft: 5,
        width: "6%",
        alignItems: "left"
    },
    textEn: {
        fontSize: 8,
        textAlign: "left",
        padding: 3
    },
    textEnCenter: {
        fontSize: 8,
        textAlign: "center",
        padding: 3
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "left",
        padding: 3
    },
    textRus: {
        fontFamily: "Times Russian",
        fontSize: 8.5,
        textAlign: "left",
        // padding: 3
    },
    textRusBold: {
        fontFamily: "Times Russian Bold",
        fontSize: 9,
        // textAlign: "center",
        padding: 3
    },
    textTimes: {
        fontSize: 9,
        fontFamily: "Times",
    },
    texttimesBold: {
        fontSize: 11,
        fontFamily: "TimesBold",
    },
    textSNNo: {
        fontSize: 11,
        textAlign: "right",
        fontFamily: 'Roboto-Bold'
        // marginRight: 75
    },
    textFinal: {
        fontSize: 11,
        textAlign: "left",
        fontFamily: 'Roboto-Bold'
    },
    tableColSN1: {
        width: '10%',
        padding: 5,
        textAlign: 'left',
    },
    tableColSN2: {
        width: '20%',
        padding: 5,
        textAlign: 'left',
    },
    tableColSN3: {
        width: '70%',
        padding: 5,
        textAlign: 'right',
    },
    qrCode: {
        alignSelf: "center",
    },
    stamp: {
        alignSelf: "center",
    },
})

const DraftC = ({ datappm, ppmDetil, ppmKontainer, ppmKemasan, ppmMutu, ppmMutuProd, ppmMutuArea, dataHc, upt, pelBongkar, totalJumlah, qrImage, spesimenTtd = null }) => {
    return (
        <Document>
            <Page size="LEGAL" style={styles.page} wrap={false}>
                {/* header */}
                <View style={styles.tableRow}>
                    <View style={[styles.tableColSN1, { border: 1 }]}>
                        <Text style={styles.textFinal}>FINAL</Text>
                    </View>
                    <View style={[styles.tableColSN2, { border: 0 }]}>
                        <Text style={styles.textBox}></Text>
                    </View>
                    <View style={[styles.tableColSN3, { border: 0 }]}>
                        <Text style={styles.textSNNo}>SN : {dataHc !== null ? dataHc.noSeriMutu : ''}</Text>
                        {/* <Text style={styles.textSNNo}></Text> */}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableColSN1, { width: '80%', border: 0 }]}>
                        <Text style={styles.textFinal}></Text>
                    </View>
                    <View style={[styles.tableColSN2, { width: '5%', border: 0 }]}>
                        <Text style={styles.textBox}></Text>
                    </View>
                    <View style={[styles.tableColSN3, { width: '15%', padding: 0, border: 0 }]}>
                        <View style={styles.qrCode}>
                            <Image src={qrImage} style={{ width: 60, height: 60 }} />
                        </View>
                    </View>
                </View>
                <View style={[styles.table]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: "20%" }]}>

                        </View>
                        <View style={[styles.tableCol, { width: "60%", alignItems: "center" }]}>
                            <View>
                                <Image style={[styles.headingImg, { alignItems: "center" }]} src={imgGaruda} />
                            </View>
                            <view>
                                <Text style={[styles.textRusBold, { textAlign: "center" }]}>РЕСПУБЛИКИ ИНДОНЕЗИЯ</Text>
                                <Text style={[styles.headingEn, { paddingLeft: 6 }]}>THE REPUBLIC OF INDONESIA</Text>
                            </view>
                            <View>
                                <Text style={[styles.textRusBold, { textAlign: "center" }]}>МИНИСТЕРСТВО МОРСКИХ И РЫБОЛОВНЫХ</Text>
                                <Text style={[styles.headingEn, { paddingLeft: 23 }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            </View>
                            <View>
                                <Text style={[styles.textRusBold, { textAlign: "center" }]}>ВЕТЕРИНАРНЫЙ СЕРТИФИКАТ</Text>
                                <Text style={[styles.headingEn, { paddingLeft: 27 }]}>SERTIFIKAT KESEHATAN</Text>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { width: "20%" }]}>
                            {/* <Image style={[styles.headingImg, { marginHorizontal: 0, width: 65, height: 65, marginVertical: 15, }]} src={imgQRCode} /> */}
                        </View>
                    </View>
                </View>
                {/* content */}
                <View style={[styles.table]}>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableCol, { width: "53%", alignItems: "left", borderRightWidth: 1 }]}>
                            <Text style={styles.textRusBold}>
                                I. Описание поставки / Penjelasan pengiriman :
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "47%", alignItems: "left", paddingTop: 3 }]}>
                            <Text style={[styles.textRus]}>
                                1.5 Сертификат № / Nomor Sertifikat : {dataHc !== null ? dataHc.noHcMutu : ''}
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableCol, { width: "53%", alignItems: "left", borderRightWidth: 1 }]}>
                            <View style={[styles.tableRow, { borderBottomWidth: 1, paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left", paddingLeft: 3 }]}>
                                    <Text style={styles.textRus}>
                                        1.1 Название и адрес грузоотправителя / Nama dan alamat pengirim :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left", paddingLeft: 3 }]}>
                                    <Text style={styles.textRus}>
                                        {dataHc !== null ? dataHc.nmPengirim : ''}
                                    </Text>
                                    <Text style={styles.textRus}>
                                        {dataHc !== null ? dataHc.alPengirim : ''}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left", paddingLeft: 3 }]}>
                                    <Text style={styles.textRus}>
                                        1.2 Название и адрес грузополучателя / Nama dan alamat penerima :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left", paddingLeft: 3 }]}>
                                    <Text style={styles.textRus}>
                                        {dataHc !== null ? dataHc.nmPenerima : ''}
                                    </Text>
                                    <Text style={styles.textRus}>
                                        {dataHc !== null ? dataHc.alPenerima : ''}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.tableCol, { width: "47%", alignItems: "left" }]}>
                            <Text style={[styles.textRusBold, { textAlign: "center" }]}>
                                Ветеринарный сертификат на экспортируемую на таможенную территорию Евразийского экономического союза пищевую продукцию из рыбы, ракообразных, моллюсков, других объектов промысла и продуктов их переработки/ Sertifikat kesehatan untuk produk pangan yang berasal dari ikan, krustasea, moluska, hewan akuatik dan produk olahannya yang diekspor ke Eurasian Economic Union
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableCol, { width: "53%", alignItems: "left", borderRightWidth: 1, borderBottomWidth: 1, paddingLeft: 3 }]}>
                            <Text style={styles.textRus}>
                                1.3 Транспорт / Sarana Tranportasi :
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                (№ вагона, автомашины, контейнера, рейса самолета, название судна)/ (Nomor kereta api, truk, container, penerbangan, nama kapal)
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "47%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { borderBottomWidth: 1, marginLeft: -1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        1.6 Страна происхождения товар/Negara Asal Produk:
                                    </Text>
                                    <Text style={[styles.headingEn, { textAlign: "left", paddingTop: 3, paddingBottom: 4, paddingLeft: 3 }]}>
                                        THE REPUBLIC OF INDONESIA
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, { borderBottomWidth: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        1.7 Страна, выдавшая сертификат/ Negara penerbit sertifikat :
                                    </Text>
                                    <Text style={[styles.headingEn, { textAlign: "left", paddingTop: 3, paddingBottom: 4, paddingLeft: 3 }]}>
                                        THE REPUBLIC OF INDONESIA
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, { borderBottomWidth: 1, marginLeft: -1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        1.8 Компетентное ведомство страны-экспортера/ Otoritas Kompeten Negara Pengekspor :
                                    </Text>
                                    <Text style={[styles.headingEn, { textAlign: "left", paddingTop: 3, paddingBottom: 4, paddingLeft: 3 }]}>
                                        MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left", borderBottomWidth: 1 }]}>
                                    <Text style={styles.textRus}>
                                        1.9 Учреждение страны-экспортера, выдавшее сертификат/ Lembaga penerbit sertifikat :
                                    </Text>
                                    <Text style={[styles.headingEn, { textAlign: "left", paddingTop: 3, paddingBottom: 4, paddingLeft: 3 }]}>
                                        {upt !== null ? upt.nmInggris : ''}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "53%", alignItems: "left", borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textRus}>
                                1.4 Страна(ы) транзита / Negara Transit :
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "47%", alignItems: "left", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textRus}>
                                1.10 Пункт пропуска товаров через таможенную границу/ Pelabuhan tujuan di Eurasian Economic Union :
                            </Text>
                            <Text style={styles.textRus}>
                                {pelBongkar !== null ? pelBongkar.uraianPelabuhan : ''}, RUSSIA
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "100%", alignItems: "left", borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textRusBold}>
                                2. Идентификация товара / Identifikasi produk :
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5, paddingTop: 3, paddingBottom: 3 }]}>
                                2.1. Наименование товара / Nama produk : {ppmMutu !== null ? ppmMutu.mutuDesk : ''}
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5, paddingTop: 3, paddingBottom: 3 }]}>
                                2.2. Дата выработки товара / Tanggal produksi produk :
                                {
                                    ppmMutuProd !== null && ppmMutuProd.map((prod, index) => {
                                        return (<>&nbsp;{prod.mutuProdTgl},</>)
                                    })
                                }
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5, paddingTop: 3, paddingBottom: 3 }]}>
                                2.3. Упаковка / Pengemasan :
                                {
                                    ppmKemasan !== null && ppmKemasan.map((kms, index) => {
                                        return (<>&nbsp;{kms.uraianKemasan},</>)
                                    })
                                }
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5, paddingTop: 3, paddingBottom: 3 }]}>
                                2.4. Количество мест / Jumlah Kemasan :
                                {
                                    ppmKemasan !== null && ppmKemasan.map((kms, index) => {
                                        return (<>&nbsp;{kms.jumlah}&nbsp;{kms.uraianKemasan},</>)
                                    })
                                }
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5, paddingTop: 3, paddingBottom: 3 }]}>
                                2.5. Bec нетто (кг) / Berat bersih (Kg) :
                                {/* {
                                    dataHc !== null ? dataHc.netto : '0'
                                } */}
                                {
                                    totalJumlah.map((detil, index) => {
                                        return (
                                            detil.totalJumlah + ' ' + detil.kodeSatuan.toUpperCase() + ';'
                                        )
                                    })
                                }
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5, paddingTop: 3, paddingBottom: 3 }]}>
                                2.6. Номер пломбы / Nomor Segel :
                                {
                                    ppmKontainer !== null && ppmKontainer.map((kont, index) => {
                                        return (<>&nbsp;{kont.nomorSegel},</>)
                                    })
                                }
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5, paddingTop: 3, paddingBottom: 3 }]}>
                                2.7. Маркировка / Identifikasi :&nbsp;
                                {
                                    ppmMutu !== null ? ppmMutu.upiRegNo : ''
                                }
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5, paddingTop: 3, paddingBottom: 3 }]}>
                                2.8. Условия хранения и перевозки / Kondisi penyimpanan dan transportasi :&nbsp;
                                {
                                    ppmMutu !== null ? ppmMutu.mutuTemp : ''
                                }
                                &nbsp;Degree Celsius
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "100%", alignItems: "left", borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textRusBold}>
                                3. Происхождениетовара / Asal produk :
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                3.1. Название, регистрационный номер и адрес предприятия/
                            </Text>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "50%" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 23, paddingTop: 3 }]}>
                                        Nama, nomor registrasi dan alamat perusahaan pengolahan :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "50%" }]}>
                                    <Text style={[styles.textRus, { paddingTop: 3 }]}>
                                        {
                                            ppmMutu !== null ? ppmMutu.upiNama : ''
                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "50%" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 23, paddingTop: 3 }]}>
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "50%" }]}>
                                    <Text style={[styles.textRus]}>
                                        {
                                            ppmMutu !== null ? ppmMutu.upiAlamat : ''
                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "50%" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 23, paddingTop: 3 }]}>
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "50%" }]}>
                                    <Text style={[styles.textRus, { paddingBottom: 7 }]}>Registration Number:
                                        {
                                            ppmMutu !== null ? ppmMutu.upiRegNo : ''
                                        }
                                    </Text>
                                </View>
                            </View>
                            <Text style={[styles.textRus, { paddingLeft: 17, paddingTop: 3, paddingBottom: 7 }]}>
                                - плавбаза/Kapal pengolah :
                                {
                                    ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '2' ? ppmMutuArea[0].mutuTangkapKapal : '***'
                                }
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 17, paddingTop: 3, paddingBottom: 7 }]}>
                                - холодильник/Gudang penyimpanan dingin :
                            </Text>
                            <Text style={[styles.textRus, { paddingLeft: 5, paddingTop: 3, paddingBottom: 5 }]}>
                                3.2. Административно-территориальная единица / Unit wilayah administrasi : &nbsp;
                                {
                                    upt !== null ? upt.nmInggris : ''
                                }
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "3%", alignItems: "left", borderLeftWidth: 1 }]}>
                            <Text style={styles.textRusBold}>
                                4.
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "97%", alignItems: "left", borderRightWidth: 1 }]}>
                            <View style={[styles.tableRow, { marginLeft: -1, paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRusBold}>
                                        Свидетельство о пригодности товара в пищу / Sertifikat kesesuaian produk untuk konsumsi manusia
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, { marginTop: -5 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRusBold}>
                                        нижеподписавшийся государственный/официальный ветеринарный врач, настоящим удостоверяю следующее!Я, Saya, Inspektur mutu yang bertandatangan di bawah ini, menyatakan bahwa:
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, { marginTop: -3 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left", paddingLeft: 3 }]}>
                                    <Text style={styles.textRus}>
                                        Сертификат выдан наоснове следующих дожспортных сертификатов (при наличии более 2 оэкспортных сертификатов прилагается списоx) / Sertifikat ini diterbitkan berdasarkan sertifikat pra-ekspor berikut (jika terdapat lebih dari dua sertifikat pra-ekspor, daftar dilampirkan):
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    {/* tabel heaeder */}
                    <View style={[styles.table, { borderBottom: 1 }]}>
                        <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <View style={[styles.tableCol, { width: "10%", alignItems: "left", borderRightWidth: 1 }]}>
                                <Text style={[styles.textRus, { textAlign: 'center' }]}>
                                    Дата/
                                </Text>
                                <Text style={[styles.textRus, { textAlign: 'center' }]}>
                                    Tanggal
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", alignItems: "left", borderRightWidth: 1 }]}>
                                <Text style={[styles.textRus, { textAlign: 'center' }]}>
                                    Номер/
                                </Text>
                                <Text style={[styles.textRus, { textAlign: 'center' }]}>
                                    Nomor
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", alignItems: "left", borderRightWidth: 1 }]}>
                                <Text style={styles.textRus}>
                                    Страна происхождения/
                                </Text>
                                <Text style={styles.textRus}>
                                    Negara Asal
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "16%", alignItems: "left", borderRightWidth: 1 }]}>
                                <Text style={styles.textRus}>
                                    Административная территория/
                                </Text>
                                <Text style={styles.textRus}>
                                    Wilayah Administratsi
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "16%", alignItems: "left", borderRightWidth: 1 }]}>
                                <Text style={styles.textRus}>
                                    Регистрационный номерпредприятия/
                                </Text>
                                <Text style={styles.textRus}>
                                    Nomor registrasi perusahaan
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", alignItems: "left" }]}>
                                <Text style={styles.textRus}>
                                    Вид и количество (веснетто) товара/
                                </Text>
                                <Text style={styles.textRus}>
                                    Jenis dan jumlah (berat bersih) barang
                                </Text>
                            </View>
                        </View>

                        {/* tabel detail */}
                        {
                            ppmDetil !== null && ppmDetil.map((detil, index) => {
                                return (
                                    <>
                                        <View key={index} style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                                            {
                                                index === 0 ?
                                                    (
                                                        <>
                                                            <View style={[styles.tableCol, { width: "10%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]}>
                                                                <Text style={[styles.headingEn, { textAlign: "left", paddingLeft: 2 }]}>
                                                                    {
                                                                        ppmMutuProd.map((mutuProd, index) => {
                                                                            return (
                                                                                <Text key={index} style={[styles.text]}>
                                                                                    {mutuProd.mutuProdTgl}
                                                                                </Text>
                                                                            )
                                                                        })
                                                                    }
                                                                </Text>
                                                            </View>
                                                            <View style={[styles.tableCol, { width: "15%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]}>
                                                                <Text style={[styles.headingEn, { textAlign: "left", paddingLeft: 2 }]}>
                                                                    {dataHc !== null ? dataHc.noHcMutu : ''}
                                                                </Text>
                                                            </View>
                                                            <View style={[styles.tableCol, { width: "20%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]}>
                                                                <Text style={[styles.headingEn, { textAlign: "left", paddingLeft: 2 }]}>
                                                                    The Republic Of Indonesia
                                                                </Text>
                                                            </View>
                                                            <View style={[styles.tableCol, { width: "16%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]}>
                                                                <Text style={[styles.headingEn, { textAlign: "left", paddingLeft: 2 }]}>
                                                                    {upt !== null ? upt.kota : ''}
                                                                </Text>
                                                            </View>
                                                            <View style={[styles.tableCol, { width: "16%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]}>
                                                                <Text style={[styles.headingEn, { textAlign: "left", paddingLeft: 2 }]}>
                                                                    {ppmMutu !== null ? ppmMutu.upiRegNo : ''}
                                                                </Text>
                                                            </View>
                                                        </>
                                                    ) :
                                                    (
                                                        <>
                                                            <View style={[styles.tableCol, { width: "10%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]} />
                                                            <View style={[styles.tableCol, { width: "15%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]} />
                                                            <View style={[styles.tableCol, { width: "20%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]} />
                                                            <View style={[styles.tableCol, { width: "16%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]} />
                                                            <View style={[styles.tableCol, { width: "16%", alignItems: "left", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }]} />
                                                        </>
                                                    )
                                            }
                                            <View style={[styles.tableCol, { width: "23%", alignItems: "left" }]}>
                                                <Text style={[styles.headingEn, { textAlign: "left", paddingLeft: 2 }]}>
                                                    {detil.namaLokal}, {detil.jumlah} {detil.kodeSatuan}
                                                </Text>
                                            </View>
                                        </View>
                                    </>
                                )
                            })
                        }
                    </View>
                </View>
            </Page>
            <Page size="LEGAL" style={styles.page} wrap={false}>
                <View>
                    <Text style={[styles.textRusBold, { textAlign: 'right' }]}>
                        Сертификат № / Nomor Sertifikat : {dataHc !== null ? dataHc.noHcMutu : ''}
                    </Text>
                </View>
                <View style={[styles.table]}>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={styles.textRus}>
                                4.1
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { marginLeft: -1, paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        Экспортируемая на таможенную территорию Евразийского экономического союза продукция из водных биологических ресурсов (живая, охлажденная, мороженая рыба, икра, моллюски, млекопитающие и другие водные животные и объекты промысла) (далеерыбная продукция) выращена и добыта в экологически чистых водоемах (акваториях), пищевые продукты ее переработки произведены на предприятиях, в отношении которых не были установлены ветеринарно-санитарные ограничения
                                    </Text>
                                    <Text style={styles.textRus}>
                                        Produk lain sumber daya alam hayati air (hidup, didinginkan, ikan beku, caviar, moluska, mamalia, dan hewan air lainnya serta produk olahannya) (selanjutnya disebut sebagai produk perikanan) yang diekspor ke Eurasian Economic Union, dibudidayakan dan dipanen dari lingkungan perairan bersih, pengolahan produk makanan yang diproduksi belum ditetapkan dalam ketentuan kesehatan hewan
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint, { width: "6%", alignItems: "left" }]}>
                            <Text style={styles.textRus}>
                                4.2
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        В случае наличия паразитов в пределах допустимых норм рыбная продукция обезврежена существующими методами
                                    </Text>
                                    <Text style={[styles.textRus]}>
                                        Jika terdapat parasit dalam batas standar yang diizinkan, produk perikanan telah diberi perlakuan dengan metode terkini.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={styles.textRus}>
                                4.3
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableColP, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        Рыбная продукция, экспортируемая на таможенную территорию Евразийского экономического союза
                                    </Text>
                                    <Text style={[styles.textRus, { marginTop: -2 }]}>
                                        Produk perikanan yang diekspor ke Eurasian Economic Union:
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={[styles.textRus, { paddingLeft: 20 }]}>
                                +
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                        не содержит ядовитых рыб семейств. Tetraodontidae, Molidae, Diodontidae u Canthigasteridae, a также рыбной продукции, содержащей биотоксины, опасные для здоровья человека/tidak mengandung ikan beracun Tetraodontidae, Molidae, Diodontidae, Canthigasteridae, dan produk perikanan yang mengandung
                                        biotoxins berbahaya bagi kesehatan manusia;
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={[styles.textRus, { paddingLeft: 20 }]}>
                                +
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                        исследована на наличие паразитов, бактериальных и вирусных инфекций/sudah diuji terhadap infeksi parasite, bakteri, dan virus;
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={[styles.textRus, { paddingLeft: 20 }]}>
                                +
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                        не содержит натуральных или синтетических эстрогенных, гормональных веществ, тиреостатических препаратов, антибиотиков, других медикаментозных средств и пестицидов / tidak mengandung zat hormone esterogen atau obat thyroid-statik alami atau sintetik, antibiotic, zat obat lain, dan pestisida;
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={[styles.textRus, { paddingLeft: 20 }]}>
                                +
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                        мороженая рыбная продукция имеет температуру в толще продукта не выше -18 °C/produk ikan beku memiliki suhu pusat tidak lebih tinggi dari minus 18 derajat Celcius;
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={[styles.textRus, { paddingLeft: 20 }]}>
                                +
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                        не контаминирована сальмонеллами или возбудителями других бактериальных инфекций / tidak terdapat salmonella atau bakteri pathogen lainnya;
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={[styles.textRus, { paddingLeft: 20 }]}>
                                +
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                        не обработана красящими веществами, ионизирующим облучением или ультрафиолетовыми лучами / Tidak diproses dengan zat pewarna, radiasi ion, atau sinar ultra violet;
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={[styles.textRus, { paddingLeft: 20 }]}>
                                +
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                        не имеет изменений, характерных для заразных болезней / tidak menunjukkan perubahan yang merupakan ciri khas dari penyakit menular;
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={[styles.textRus, { paddingLeft: 20 }]}>
                                +
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                        не имеет недоброкачественных изменений по органолептическим показателям / tidak menunjukkan perubahan negatif yang mempengaruhi kualitas organoleptik;
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={[styles.textRus, { paddingLeft: 20 }]}>
                                +
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow, { paddingRight: 1 }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={[styles.textRus, { paddingLeft: 5 }]}>
                                        не подвергалась дефростации в период хранения/ belum dicairkan selama masa penyimpanan.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={styles.textRus}>
                                4.4
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        Двустворчатые моллюски, иглокожие, оболочники и морские гастроподы прошли необходимую выдержку в центрах очистки/
                                    </Text>
                                    <Text style={[styles.textRus]}>
                                        Bivalva, Echinodermata, tunicate, dan gastropoda laut telah disimpan selama masa yang diperlukan pada pusat purifikasi.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={styles.textRus}>
                                4.5
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        Микробиологические, химикотоксикологические и радиологические показатели рыбной продукции, содержание фикотоксинов и других загрязнителей (для моллюсков) соответствуют действующим на таможенной территории Евразийского экономического союза ветеринарным и санитарным нормам и правилам/
                                    </Text>
                                    <Text style={[styles.textRus]}>
                                        Racun mikrobiologi, kimia dan indikator radiologi produk perikanan yang mengandung phytotoxins dan kontaminan lainnya (untuk moluska) sesuai dengan standar kesehatan dan aturan yang saat ini berlaku di Eurasian Economic Union.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={styles.textRus}>
                                4.6
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        Рыбная продукция признана пригодной для употребления в пищу человеку./
                                    </Text>
                                    <Text style={[styles.textRus]}>
                                        Produk ikan telah sesuai untuk konsumsi manusia.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={styles.textRus}>
                                4.7
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        Тара и упаковочный материал одноразовые и соответствуют требованиям Евразийского экономического союза./
                                    </Text>
                                    <Text style={[styles.textRus]}>
                                        Kemasan dan bahan pengemas dapat diuraikan dan memenuhi persyaratan dari Eurasian Economic Union.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableColPoint]}>
                            <Text style={styles.textRus}>
                                4.8
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "94%", alignItems: "left" }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                                    <Text style={styles.textRus}>
                                        Транспортное средство обработано и подготовлено в соответствии с правилами, принятыми в стране-экспортере./
                                    </Text>
                                    <Text style={[styles.textRus]}>
                                        Sarana transportasi telah diperlakukan dan dipersiapkan sesuai dengan persyaratan dari Negara
                                        pengekspor.
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    {/* footer */}
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, borderRightWidth: 1, paddingTop: 40 }]}>
                        <View style={[styles.tableCol, { width: "33.33%", alignItems: "left" }]}>
                            <Text style={styles.textRus}>
                                Место/Tempat {upt !== null ? upt.kota : ''}
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "33.33%", alignItems: "left" }]}>
                            <Text style={styles.textRus}>
                                Дата/Tanggal {dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "33.33%", alignItems: "left" }]}>
                            <Text style={styles.textRus}>
                                Печать/Stempel resmi
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, paddingTop: 25 }]}>
                        <View style={[styles.tableCol, { width: "75%", alignItems: "left" }]}>
                            <Text style={styles.textRus}>
                                Подпись государственного /официального ветеринарного врача
                            </Text>
                            <Text style={styles.textRus}>
                                Tandatangan Inspektur Mutu
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "25%", flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }]}>
                            <View style={[styles.stamp, { marginRight: 15 }]}>
                                <Image src={imgStempel} style={{ width: 70, height: 70 }} />
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                        <View style={[styles.tableCol, {width:"100%", flexDirection: 'row', alignItems: 'left', justifyContent: 'flex-start' }]}>
                            <View style={styles.stamp}>
                                <Image src={spesimenTtd} style={{ width: 100, height: 60 }} />
                            </View>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, paddingTop: 10 }]}>
                        <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                            <Text style={styles.textRus}>
                                Ф.И.О. и должность
                            </Text>
                            <Text style={styles.textRus}>
                                Nama dan posisi
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, paddingLeft: 23, paddingTop: 30 }]}>
                        <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                            <Text style={styles.textRus}>
                                {dataHc !== null ? dataHc.nmPejabat : ''} / OFFICIAL INSPECTOR
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, paddingLeft: 23 }]}>
                        <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                            <Text style={styles.textRus}>
                                {upt !== null ? upt.nmInggris : ''}
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1, paddingBottom: 108 }]}>
                        <View style={[styles.tableCol, { width: "100%", alignItems: "left" }]}>
                            <Text style={styles.textRus}>
                                Примечание. Подпись и печать должны отличаться цветом от бланка
                            </Text>
                            <Text style={styles.textRus}>
                                Catatan. Tandatangan dan stempel harus berbeda warna dengan tulisan yang dicetak pada sertifikat
                            </Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document >
    )
}

export default DraftC